import { DetailsSubpanels, DetailsToolbar, PrimaryDetails } from 'components/page/index';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Enums from 'utils/EnumsManager';
import { getThemeByType } from 'utils/common';
import { resetTools } from 'components/page/DetailsToolbar/flow/actions';
import { resetSections } from 'components/page/PrimaryDetails/flow/actions';
import { resetModules } from 'components/page/DetailsSubpanels/flow/actions';

const { PhantomId } = Enums;

class ObjectDetails extends Component {

  componentWillUnmount() {
    const { resetTools, resetSections, resetModules } = this.props;
    resetTools();
    resetSections();
    resetModules();
  }

  render() {
    const {
      accountId,
      objectId,
      objectType,
      tools,
      deleted,
      modules,
    } = this.props;
    const theme = getThemeByType(objectType);

    const commonProps = {
      objectId,
      objectType,
      theme,
    };

    return (
      <Fragment>
        {objectId !== PhantomId && <DetailsToolbar {...commonProps} tools={tools} deleted={deleted} />}
        <PrimaryDetails {...commonProps} accountId={accountId} />
        {objectId !== PhantomId && <DetailsSubpanels {...commonProps} modules={modules} />}
      </Fragment>
    );
  }
}


const mapStateToProps = ({ clientDetails }) => ({
  tools: clientDetails.toolbar.tools,
  deleted: clientDetails.toolbar.deleted,
  modules: clientDetails.subpanels.modules,
});
const mapDispatchToProps = {
  resetTools,
  resetSections,
  resetModules
};
export default connect(mapStateToProps, mapDispatchToProps)(ObjectDetails);



// WEBPACK FOOTER //
// ./src/views/ClientDetails/container/index.jsx